import { render } from "./PVastPlayer.vue?vue&type=template&id=18b97469&scoped=true"
import script from "./PVastPlayer.vue?vue&type=script&lang=js"
export * from "./PVastPlayer.vue?vue&type=script&lang=js"

import "./PVastPlayer.vue?vue&type=style&index=0&id=18b97469&scoped=true&lang=css"

import exportComponent from "/builds/sqMDsSTzB/0/dsp/plazkart-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b97469"]])

export default __exports__